module.exports = __webpack_public_path__ + "static/purplesquid-dd24552d63c9fb75dce648a263e4f26c.png";